const PlusIcon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    className={className}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M16 8H0'
      stroke='currentColor'
      strokeWidth='2'
      fill='currentColor'
    />
    <path
      d='M8 0V16'
      stroke='currentColor'
      strokeWidth='2'
      fill='currentColor'
    />
  </svg>
);
export default PlusIcon;
